module.exports = __webpack_public_path__ + "img/imetame.eaa4c8aa.svg";